import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.svg'
import _imports_1 from '@/assets/icons/maintenance.svg'
import _imports_2 from '@/assets/icons/reload.svg'


const _hoisted_1 = { class: "position-fixed top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-white text-center offline-mode" }
const _hoisted_2 = { class: "offline-content mt-5" }
const _hoisted_3 = { class: "fw-bold mb-3" }
const _hoisted_4 = { class: "lead mb-4 px-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("header", { class: "offline-header w-100" }, [
      _createElementVNode("img", {
        src: _imports_0,
        alt: "Energielenker Connect",
        class: "offline-logo-header"
      })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('offline.headline')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('offline.message')), 1),
      _cache[2] || (_cache[2] = _createElementVNode("img", {
        src: _imports_1,
        alt: "Wartung",
        class: "offline-img mb-4"
      }, null, -1)),
      _createElementVNode("button", {
        class: "btn btn-reload d-flex align-items-center justify-content-center mx-auto",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reloadPage && _ctx.reloadPage(...args)))
      }, [
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          src: _imports_2,
          alt: "Neu laden",
          class: "reload-icon me-2"
        }, null, -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('common.reload')), 1)
      ])
    ])
  ]))
}